import { createSlice } from "@reduxjs/toolkit"
import {
  exportByType,
  getCityData,
  getDropdownData,
  getJobTitlesList,
  getSystemNationalities,
  getStationShiftDropdownList,
} from "store/actions/commonAction"

const bloodGroups = [
  { id: 1, name: "A+" },
  { id: 2, name: "A-" },
  { id: 3, name: "B+" },
  { id: 4, name: "B-" },
  { id: 5, name: "AB+" },
  { id: 6, name: "AB-" },
  { id: 7, name: "O+" },
  { id: 8, name: "O-" },
]

const initialState = {
  isExporting: false,
  dropdownData: {},
  jobTitlesList: [],
  citiesList: [],
  systemNationalities: [],
  bloodGroups,
  work_shifts: {},
  stations: {},
  mealTypes: {},
}

const usersSlice = createSlice({
  name: "dropdown",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getDropdownData.pending, state => {})
      .addCase(getDropdownData.fulfilled, (state, action) => {
        const { success, data } = action.payload || {}
        if (success) {
          state.dropdownData = data
        }
      })
      .addCase(getDropdownData.rejected, (state, action) => {})

    builder
      .addCase(getJobTitlesList.pending, state => {})
      .addCase(getJobTitlesList.fulfilled, (state, action) => {
        const { success, data } = action.payload || {}
        if (success) {
          state.jobTitlesList = data
        }
      })
      .addCase(getJobTitlesList.rejected, (state, action) => {})

    builder
      .addCase(exportByType.pending, state => {
        state.isExporting = true
      })
      .addCase(exportByType.fulfilled, (state, action) => {
        state.isExporting = false
        const { success, data } = action.payload || {}
      })
      .addCase(exportByType.rejected, (state, action) => {
        state.isExporting = false
      })

    builder
      .addCase(getCityData.pending, state => {})
      .addCase(getCityData.fulfilled, (state, action) => {
        const { success, data } = action.payload || {}
        if (success) {
          state.citiesList = data
        }
      })
      .addCase(getCityData.rejected, (state, action) => {})
    builder
      .addCase(getSystemNationalities.pending, state => {})
      .addCase(getSystemNationalities.fulfilled, (state, action) => {
        const { success, data } = action.payload || {}
        if (success) {
          state.systemNationalities = data
        }
      })
      .addCase(getSystemNationalities.rejected, (state, action) => {})
    builder
      .addCase(getStationShiftDropdownList.pending, state => {})
      .addCase(getStationShiftDropdownList.fulfilled, (state, action) => {
        const { success, data } = action.payload || {}
        if (success) {
          state.work_shifts = data.work_shifts
          state.stations = data.stations
          state.mealTypes = data.meal_types
        }
      })
      .addCase(getStationShiftDropdownList.rejected, (state, action) => {})
  },
})

export default usersSlice.reducer
